import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import classNames from 'classnames';
import { IRoute } from 'interfaces';
import logo from 'assets/images/logo.png';
import logoVnng from 'assets/images/logo-512.png';
import logoVnpay from 'assets/images/logo-vnpay-512.png';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { useDevice } from 'packages/device/hooks';

import AppMenu from '../AppMenu';
import { localStorageConstants } from '../../../constants';
const { COMPANY_ID } = localStorageConstants;

const { Sider } = Layout;

var currentLogo = logo;
if (localStorage.getItem(COMPANY_ID) === window.COMPANY_ID_VNNG.toString()) {
  currentLogo = logoVnng;
}
if (
  localStorage.getItem(COMPANY_ID) === window.COMPANY_ID_NAB.toString() ||
  localStorage.getItem(COMPANY_ID) === window.COMPANY_ID_DIGILIFE.toString()
) {
  currentLogo = logoVnpay;
}

interface AppSiderProps {
  filteredNavigation: IRoute[];
}

const AppSider: React.FC<AppSiderProps> = props => {
  const [visible, setVisible] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { device } = useDevice(setVisible);
  // Get selectedKey, openKey from route & pathname
  const { filteredNavigation } = props;
  const onClickToggle = () => {
    setVisible(!visible);
  };

  if (device !== 'mobile')
    return (
      <Sider
        className={classNames({
          'app-sider': true,
          collapsed: !visible,
        })}
        trigger={null}
        collapsible
        collapsed={!visible}
        width={270}
      >
        <div className="app-logo">
          <Link to="/">
            <img src={currentLogo} alt="logo" />
          </Link>
          <div
            style={{ position: 'absolute', right: 30, top: visible ? 60 : 70 }}
          >
            {visible ? (
              <>
                <MenuFoldOutlined
                  data-testid="menu-collapse-icon ml-base"
                  className="app-icon"
                  onClick={onClickToggle}
                  style={{ color: '#fff' }}
                />
              </>
            ) : (
              <MenuUnfoldOutlined
                data-testid="menu-expand-icon"
                className="app-icon"
                onClick={onClickToggle}
                style={{ color: '#fff' }}
              />
            )}
          </div>
        </div>

        <AppMenu filteredNavigation={filteredNavigation} />
      </Sider>
    );
  return null;
};

export default AppSider;
